import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import useSet from "../utils/useSet.js";
const ModalRegisterContext = /*#__PURE__*/React.createContext({
  add: noop,
  delete: noop
});
const useModalRegisterEffect = enabled => {
  const self = React.useRef();
  const modalRegisterSet = React.useContext(ModalRegisterContext);
  React.useEffect(() => {
    if (enabled) {
      modalRegisterSet.add(self);
    } else {
      modalRegisterSet.delete(self);
    }
    return () => modalRegisterSet.delete(self);
  }, [enabled, modalRegisterSet]);
};
const ModalRegisterProvider = _ref => {
  let {
    children
  } = _ref;
  const [modalsRegisteredSet, registerActions] = useSet();
  const anyModalsAreOpen = modalsRegisteredSet.size > 0;
  return /*#__PURE__*/React.createElement(ModalRegisterContext.Provider, {
    value: registerActions
  }, children(anyModalsAreOpen));
};
process.env.NODE_ENV !== "production" ? ModalRegisterProvider.propTypes = {
  children: PropTypes.func
} : void 0;
export { useModalRegisterEffect, ModalRegisterProvider };